export const SectionHeading = ({
  overline,
  title,
  subtitle,
  align = "left",
  className = "",
}) => {
  const alignment = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={`flex flex-col gap-3 ${alignment} ${align === "center" ? "max-w-2xl" : ""} ${className}`}>
      {overline && (
        <span className="font-mono-data text-xs font-semibold uppercase tracking-[0.25em] text-brand-cyan">
          {overline}
        </span>
      )}
      <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl">
        {title}
      </h2>
      {subtitle && (
        <p className="max-w-2xl text-base leading-relaxed text-brand-silver">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeading;
